var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, } from 'react';
import { ARROW_DOWN_KEY, ENTER_KEY, SPACE_KEY } from '#constants';
import { C } from '#integrations';
import { isFirefox } from '#services';
import { CalendarIcon } from '../../../../icons';
import { EndSlotButton, InputView } from '../../../components/InputView';
import { InputViewTestIdFactory } from '../../../components/InputView/interactions';
import { DatePickerTestIdFactory } from '../../interactions';
import { formatDate } from './DateInput.services';
import styles from './DateInput.module.css';
export const DateInput = ({ calendarButtonAriaLabel, 'data-testid': testId, id, inputClassName, isPopupOpen, onChange, onIconClick, onInputKeyDown, onKeyboardOpen, onPointerOpen, value = new Date(), ...props }) => {
    _react_refresh_temp_2();
    const formattedDate = formatDate(value);
    const shouldRenderCalendarButton = !isFirefox();
    const dialogId = isPopupOpen ? `${id}-dialog` : undefined;
    const onClick = useCallback((event) => {
        event.preventDefault();
        onPointerOpen();
    }, [onPointerOpen]);
    const onKeyDown = useCallback((event) => {
        if (event.key === ENTER_KEY) {
            event.preventDefault();
        }
        const isOpenKey = event.key === SPACE_KEY ||
            (event.key === ARROW_DOWN_KEY && event.altKey);
        if (isOpenKey) {
            event.preventDefault();
            onKeyboardOpen();
        }
        onInputKeyDown?.(event);
    }, [onInputKeyDown, onKeyboardOpen]);
    return (_jsx(InputView, { ...props, "aria-controls": dialogId, "aria-haspopup": "dialog", "data-testid": testId, EndSlot: shouldRenderCalendarButton && (_jsx(EndSlotButton, { "aria-controls": dialogId, "aria-expanded": isPopupOpen, "aria-haspopup": "dialog", "aria-label": calendarButtonAriaLabel, "data-testid": InputViewTestIdFactory.getInputViewEndSlotButtonTestId(DatePickerTestIdFactory.getDatePickerBase(), testId), Icon: CalendarIcon, onClick: onIconClick })), id: id, inputClassName: C(styles.HideNativeCalendarIcon, styles.AdjustInputSizeForSafari, inputClassName), onChange: (e) => onChange(new Date(e.target.value)), onClick: onClick, onKeyDown: onKeyDown, testComponentPrefix: DatePickerTestIdFactory.getDatePickerBase(), type: "date", value: formattedDate }));
};
_react_refresh_temp_1 = DateInput;
$RefreshReg$(_react_refresh_temp_1, "DateInput");
_react_refresh_temp_2(DateInput, "XJ1eITbXMpNbbxnGCueThmIM5/0=");
